import React, { useState } from 'react';
import styled from 'styled-components';
import TourModal from './TourModal';

const Card = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: 142.5px;
  object-fit: cover;
`;

const CardContent = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CardTitle = styled.h3`
  font-size: 1.2rem;
  color: #14464F;
  margin: 0;
  font-family: 'Poppins', sans-serif;
  text-align: left;
`;

const Price = styled.div`
  color: #316C6E;
  font-weight: 600;
  font-size: 0.95rem;
  text-align: left;
`;

const TourCard = ({ tour }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getFirstImage = (imageUrl) => {
    try {
      return Array.isArray(imageUrl) ? imageUrl[0] : imageUrl;
    } catch {
      return imageUrl;
    }
  };

  const handleClick = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <Card onClick={handleClick}>
        <CardImage src={getFirstImage(tour.image_url)} alt={tour.name} />
        <CardContent>
          <CardTitle>{tour.name}</CardTitle>
          <Price>${Number(tour.price).toLocaleString()} DOP</Price>
        </CardContent>
      </Card>
      {isModalOpen && (
        <TourModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          tour={tour}
        />
      )}
    </>
  );
};

export default TourCard; 